// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"J0iUL3IToQOTwnSJco1JV","icon":"_1iH45aOAWtpG6mFp905vEh"};